import React, { useEffect } from "react";
import styled from "styled-components";
import { navLinks } from "../config";
import Menu from "./menu";
import scrollTo from "gatsby-plugin-smoothscroll";
import File from "../assets/icons/file.svg";

const StyledNavLogo = styled.a`
  cursor: pointer;
  h2 {
    font-weight: bold;
    margin: 0;
    color: var(--black-dark);
  }
  &:hover h2 {
    color: var(--primary);
  }
`;

const StyledNavBar = styled.header`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-fixed);
  background-color: var(--background);
  color: var(--black-dark);
`;

const StyledNavMenu = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: 100%;
  grid-column-gap: 2rem;
  margin-left: var(--mb-2);
  margin-right: var(--mb-2);
  height: var(--header-height);

  @media (min-width: 1024px) {
    margin-left: var(--mb-4);
    margin-right: var(--mb-4);
  }
`;

const StyledMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyleNavMenuList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyleNavMenuListItem = styled.li`
  float: left;
  position: relative;
  display: flex;

  &:hover a {
    color: var(--primary);
  }
`;

const StyledNavLink = styled.a`
  color: var(--black-dark);
  font-size: var(--small-font-size);
  cursor: pointer;
  font-weight: var(--font-semi);
  margin-left: var(--mb-2);
  margin-right: var(--mb-2);

  @media (min-width: 1024px) {
    margin-left: var(--mb-3);
    margin-right: var(--mb-3);
  }
`;

const StyledResumeButton = styled.a`
  display: block;
  border-radius: var(--border-radius);
  position: relative;
  padding: 8px 6px;
  color: var(--black-dark);
  background: var(--white);
  overflow: hidden;
  border: 2px solid var(--black-dark);
  font-size: var(--small-font-size);
  cursor: pointer;
  font-weight: var(--font-semi);
  margin-left: var(--mb-2);
  margin-right: var(--mb-2);

  @media (min-width: 1024px) {
    margin-left: var(--mb-3);
    margin-right: var(--mb-3);
  }

  #resume-icon {
    display: none;
    z-index: var(--z-normal);
  }

  &:hover span {
    visibility: hidden;
  }

  &::before,
  &::after {
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    background: var(--black-dark);
    z-index: -1;
  }

  &::before {
    transform: translateX(-100%);
    z-index: 1;
  }

  &:hover:before {
    transform: translateX(0);
    transition: transform 350ms ease;
  }

  &::after {
    z-index: 0;
    transform: translateX(100%);
    transition: none;
    transition: transform 350ms ease;
  }

  &:hover:after {
    opacity: 1;
    transform: translateX(0);
    transition: transform 350ms 360ms ease;
  }

  &:hover #resume-icon {
    position: absolute;
    top: 15%;
    left: 35%;
    fill: white;
    display: block;
  }
`;

const StyledResumeButtonSpan = styled.span`
  z-index: 5;
  position: relative;
  transition: color 350ms ease;
`;

const NavBar = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", _handleScrollActive);

      return () => {
        window.removeEventListener("scroll", _handleScrollActive);
      };
    }
  }, []);

  const _handleScrollActive = () => {
    const sections = document.querySelectorAll("section[id]");

    const scrollY = window.pageYOffset;

    sections.forEach((current) => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 60;
      const sectionId = current.getAttribute("id");
      const sectionNavId = sectionId.slice(0, sectionId.indexOf("-section"));

      if (sectionNavId !== "hero") {
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          document
            .querySelector(".nav-menu a[href*=" + sectionNavId + "]")
            .classList.add("active-link");
        } else {
          document
            .querySelector(".nav-menu a[href*=" + sectionNavId + "]")
            .classList.remove("active-link");
        }
      }
    });
  };

  return (
    <StyledNavBar>
      <StyledNavMenu>
        <StyledNavLogo href="/">
          <h2>zijian.me</h2>
        </StyledNavLogo>
        <StyledMenu>
          <StyleNavMenuList className="nav-menu">
            {navLinks.map((link) => {
              return (
                <StyleNavMenuListItem key={link.name}>
                  <StyledNavLink
                    href={link.url}
                    onClick={(event) => {
                      event.preventDefault();
                      scrollTo(link.url);
                    }}
                  >
                    {link.name}
                  </StyledNavLink>
                </StyleNavMenuListItem>
              );
            })}
          </StyleNavMenuList>
          <StyledResumeButton
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledResumeButtonSpan>Resume</StyledResumeButtonSpan>
            <File id="resume-icon" />
          </StyledResumeButton>
        </StyledMenu>
        <Menu />
      </StyledNavMenu>
    </StyledNavBar>
  );
};

export default NavBar;
